<template>
  <div id="app">
    <div id="all-loading" class="text-center">
      <div class="d-grid">
        <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x"/>
      </div>
    </div>
    <DominioInvalido v-if="!dominioValido" />
    <LoginPage v-if="deveExibirLogin" />
    <Main v-if="podeExibirMain" />
  </div>
</template>

<script>
// @ is an alias to /src
import DominioInvalido from '@/components/DominioInvalido.vue'
import LoginPage from '@/components/LoginPage.vue'
import Main from '@/components/Main.vue'
import store from '@/store'

export default {
  name: 'App',
  components: {
    DominioInvalido,
    LoginPage,
    Main
  },
  data() {
    return {
      dadosEmpresa: true,
      intervaloAtualizaDadosEmpresa: undefined,
    }
  },
  methods: {
    atualizaDadosEmpresa() {
      this.dadosEmpresa = JSON.parse(localStorage.getItem('companyData'));
    },
  },
  computed: {
    dominioValido() {
      return (!!this.dadosEmpresa && !!this.dadosEmpresa.nome_fantasia);
    },
    deveExibirLogin() {
      return (this.dominioValido && !store.getters['auth/hasToken']);
    },
    podeExibirMain() {
      return (this.dominioValido && !this.deveExibirLogin);
    }
  },
  created() {
    store.dispatch('auth/ActionCheckCompanyData');
    this.atualizaDadosEmpresa();
    this.intervaloAtualizaDadosEmpresa = setInterval(this.atualizaDadosEmpresa, 250);
  },
  destroyed() {
    clearInterval(this.intervaloAtualizaDadosEmpresa);
  },
}
</script>


<style>
#app {
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  font-family: 'Source Sans Pro','Helvetica Neue',Helvetica,Arial,sans-serif;
  font-weight: 400;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#all-loading {
  width: calc(100vw);
  height: calc(100vh);
  background-color: rgba(0, 0, 0, .5);
  color: #fefefe;
  z-index: 5500;
  position: absolute;
  left: 100;
  top: 100;
  display: none;
  align-items: center;
  justify-content: center;
}
#all-loading.show {
  display: flex;
}

.tab-pane {
  padding-top: 4px;
}

.modal-fullscreen-margin {
  max-width: calc(100vw - 16px) !important;
}

@media (min-width: 576px) {
  .modal-dialog {
      max-width: calc(100vw - 56px) !important;
  }
}

label.required:after {
  content:"*";
  color:red;
}

/** botões para computador apenas */
@media (min-width: 576px) {
  .table-sm-pc>:not(caption)>*>* {
    padding: .25rem .25rem;
  }
  .table .btn-sm {
    padding: .15rem .35rem !important;
    font-size: .755rem !important;
    border-radius: .2rem !important;
  }
}

/* dialogo de confirmação */
.dg-main-content {
    max-width: 600px !important;
}

.dg-title {
  margin-bottom: 6px !important;
  color: #5f5f5f;
}

.dg-content {
  border-top: 2px solid #E1E6EA;
  padding-top: 6px;
}

.dg-btn.dg-btn--cancel {
  color: #0096D9;
  background-color: #fefefe;
  border-color: #0096D9;
}

.dg-btn.dg-btn--ok {
  color: #fefefe;
  background-color: #0096D9;
}

.dialogo-alerta .dg-title {
  color: #ffb20b;
}

.dialogo-alerta .dg-btn {
  background-color: #ffb20b;
  border-color: #ffb20b;
}
/* dialogo de confirmação */

.text-muted-2 {
  color: #b5b5b5 !important;
}

.text-warning {
  color: #ffae00 !important;
}
</style>
